import { DepartmentsEnum } from '@moonpig/web-shared-types-graphql'

const DIGITAL_GIFT_CATEGORIES = [
  DepartmentsEnum.DIGITAL_GIFT_CARDS,
  DepartmentsEnum.DIGITAL_GIFTS,
]

// this should check the flow of the product not the department
export const isProductPrintedInCard = (department: DepartmentsEnum) =>
  DIGITAL_GIFT_CATEGORIES.includes(department)
